import m from "../../geodata/es2015/belgiumHigh";
window.am4geodata_belgiumHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/belgiumHigh.js
// module id = null
// module chunks = 